module.exports = __webpack_public_path__ + "img/2024-ford-f-150-lightning.bdc0b577.png";